import { render, staticRenderFns } from "./ReferenceForm.vue?vue&type=template&id=37790b34&scoped=true&"
import script from "./ReferenceForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceForm.vue?vue&type=style&index=0&id=37790b34&prod&lang=scss&"
import style1 from "./ReferenceForm.vue?vue&type=style&index=1&id=37790b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37790b34",
  null
  
)

export default component.exports